module.exports = __webpack_public_path__ + "static/atoyebi-b2da17822322f7409a12ca2e243374d0.png";